class collectedRegister {

    static values = {};

    static setValue(key, value){

        let collected_values = {};
        try{
            if(sessionStorage.getItem('collected-values')){
                collected_values = JSON.parse(sessionStorage.getItem('collected-values'));
            }else{
                collected_values = collectedRegister.values;
            }
        }catch(error){
            collected_values = collectedRegister.values;
        }
        
        collected_values[key] = value;

        try {
            sessionStorage.setItem('collected-values', JSON.stringify(collected_values));
        }catch (e) {
            console.log(e);
        }
    }

    static getValue(key){
        try {
            if(sessionStorage.getItem('collected-values')){
                let values = JSON.parse(sessionStorage.getItem('collected-values'));
                return values[key];
            }else{
                return collectedRegister.values[key];
            }
        }catch (e) {
            return collectedRegister.values[key];
        }
    }

    static removeValue(key){
        delete collectedRegister.values[key];
        try {
            if(sessionStorage.getItem('collected-values')){
                let values = JSON.parse(sessionStorage.getItem('collected-values'));
                delete values[key];
                sessionStorage.setItem('collected-values', JSON.stringify(values));
            }
        }catch (e) {}
    }

    static remove(){
        try {
            sessionStorage.removeItem('collected-values');
        }catch (e) {}
        collectedRegister.values = {};
    }

}

export {collectedRegister}


// WEBPACK FOOTER //
// ./src/services/collectedRegister.js